import { logSpacesDatapoint } from 'owa-timestream-logging';
import type { ProjectId, AssetId } from '../schema';
import isLocalAssetId from '../assetId/isLocalAssetId';
import getProjects from '../selectors/getProjects';
import getAssetOrUndefined from '../selectors/getAssetOrUndefined';

export default function logAssetNotFound(projectId: ProjectId, assetId: AssetId): void {
    const isLookingForLocalAsset = isLocalAssetId(assetId);
    const allProjects = getProjects();
    let projectIdWithAsset: ProjectId | null = null;
    for (let i = 0; i < allProjects.length; i++) {
        const asset = getAssetOrUndefined(allProjects[i].projectId, assetId);
        if (!!asset) {
            projectIdWithAsset = allProjects[i].projectId;
            break;
        }
    }
    logSpacesDatapoint('OUTLOOKSPACES_ASSET_NOT_FOUND', {
        isLookingForLocalAsset,
        projectIdQueried: projectId,
        assetIdQueried: assetId,
        projectIdWithAsset: projectIdWithAsset ?? '',
    });
}
